import { updatePlaidCreditCardTransaction } from '../../../graphql/custom_mutations';
import PropTypes from 'prop-types';
import { generateClient } from "aws-amplify/api";
const client = generateClient();

export const updateTransaction = async (props) => {
  if (!props) return;

  console.log('updatePlaidCreditCardTransaction props: ', props);
  
  try {
    const gqlParams = { input: props };

    console.log('gqlParams: ', gqlParams);
    
    const response = await client.graphql({
      query: updatePlaidCreditCardTransaction,
      variables: gqlParams
    });
    
    console.log('updatePlaidCreditCardTransaction response: ', response);

    // Amplify can RESOLVE (not throw) with data AND a partial errors array for
    // field-level failures. Surface those so a partial write can't look clean.
    if (response?.errors?.length) {
      console.error(
        '⚠️ updatePlaidCreditCardTransaction returned PARTIAL errors (data still returned):',
        JSON.stringify(response.errors, null, 2)
      );
    }
    
    const results = response.data.updateSpkPlaidCreditCardTransactionTbl.id;
    console.log('updatePlaidCreditCardTransaction results: ', results);
    
    return results;
  } catch (err) {
    // Log the full GraphQL error detail (message / errorType / path) so a
    // failed write can be diagnosed instead of vanishing.
    console.error('❌ updatePlaidCreditCardTransaction FAILED:', {
      message: err?.message,
      errors: err?.errors,
      raw: err,
    });
    return [err];
  }
};

updateTransaction.propTypes = {
  props: PropTypes.object.isRequired,
};
